// extracted by mini-css-extract-plugin
module.exports = {"container":"Dimension_container__z5wqw","label":"Dimension_label__2h4Jk","graph":"Dimension_graph__3Bx7k","nodata":"Dimension_nodata__tcdp9"};